import { type ReactElement } from 'react';
import { useTheme } from '@/context/ThemeContext';
import LogoMainHorizontal from './LogoMainHorizontal';
import LogoMainHorizontalWhite from './LogoMainHorizontalWhite';

function ThemeAwareLogoMainHorizontal(): ReactElement {
    const { resolvedTheme } = useTheme();

    return resolvedTheme === 'dark' ? <LogoMainHorizontalWhite /> : <LogoMainHorizontal />;
}

export default ThemeAwareLogoMainHorizontal;
